import { Column, Row } from '@unistocks/components/layout/flex';
import { Paragraph } from '@unistocks/components/text/text';
import { t } from '@unistocks/localization';
import { HOME_PAGE_URL } from '@unistocks/shared/consts';
import { Anchor } from 'tamagui';

export const ExternalAccountsTermsAndConditions = () => {
  return (
    <>
      <Row flexWrap="wrap" mt={'$7'} justifyContent={'center'}>
        <Paragraph size={'$2'} textAlign={'center'}>
          {t('::ExternalAccounts:Sync:TermsAndConditions1')}
        </Paragraph>

        <Anchor
          textAlign={'center'}
          size={'$2'}
          color={'$unistocks'}
          textDecorationLine={'underline'}
          href={`${HOME_PAGE_URL}/terms-of-service`}
        >
          {t('::TermsAndConditions')}
        </Anchor>
      </Row>

      <Column mt={'$2'}>
        <Paragraph textAlign={'center'} size={'$2'}>
          {t('::ExternalAccounts:Sync:TermsAndConditions2')}
        </Paragraph>

        <Row justifyContent={'center'}>
          <Paragraph size={'$2'}>{t('::Import:BankAccountBankIdCustom:ReadMore')}</Paragraph>
          <Anchor
            size={'$2'}
            color={'$unistocks'}
            textDecorationLine={'underline'}
            href={`${HOME_PAGE_URL}/terms-of-service`}
          >
            {t('::Here')}
          </Anchor>
        </Row>
      </Column>
    </>
  );
};
